import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { User } from 'src/app/models/User';
import { OdenpermissionProvider } from 'src/app/providers/OdenpermissionProvider';
import { UserProvider } from 'src/app/providers/UserProvider';

@Injectable({
  providedIn: 'root'
})
export class RolServiceService {

  user: User;
  package: any;
  odenPersmissions = [];

  constructor(
    private storage: Storage,
    private odenPermissionProvider: OdenpermissionProvider,
    private userProvider: UserProvider,
  ) { }
  public async getUserRol(): Promise<number> {
    this.user = await this.storage.get("user");
    return this.user.id_rol;
  }
  public async getPackageGym(): Promise<any> {
    this.package = await this.storage.get('gymSubscription');
    return this.package == null ? '' : this.package.data;
  }

  async getUserPermissions(user_id?) {
    let userInfo;
    if (user_id) {
      userInfo = await this.userProvider.getUser(user_id, true);
    } else {
      userInfo = await this.storage.get('user');
    }
    // recarga los permisos de la app
    if(!userInfo.permissions)
      userInfo.permissions = this.getOdenPermissionsByRol(userInfo.id_rol);    
    await this.storage.set('user', userInfo);
    return userInfo;
  }

  async getOdenPermissions() {
    this.odenPersmissions = await this.odenPermissionProvider.index({ filtro: 'all' });
  }
  getOdenPermissionsByRol(rol) {    
    const objPermisos = this.odenPersmissions.reduce((acc, item) => {
      const status_by_role: any[] = JSON.parse(item.status_by_rol);
      acc[item.name] = status_by_role.includes(rol);
      return acc;
    }, {} as any);
    return objPermisos;
  }
}
